import { useRef, useEffect } from "react";
import { select, axisBottom } from "d3";

import "./YAxis.css";


export const XAxis = ({ xScale, innerHeight, timelineblock, ticks=10 }) => {
  const ref = useRef();
  let translate = 0;
  if (timelineblock) {
    translate = innerHeight;
  }
  useEffect(() => {
    const xAxisG = select(ref.current);
    const xAxis = axisBottom(xScale).tickPadding(2).ticks(ticks);
    xAxisG.call(xAxis);
  }, [xScale, innerHeight]);
  return <g className="xaxis" transform={`translate(${translate},${innerHeight})`} ref={ref} />;
};
